import CyclesLayout from './CyclesLayout';
import CycleActivityAccordion from './sdlcActivities/CycleActivityAccordion';

const SDLCLayout = () => {
  return (
    <>
      <CyclesLayout />
      <CycleActivityAccordion />
    </>
  );
};
export default SDLCLayout;
